import { api } from "../http";
import { ApiResponse } from "../types";
import {
  StudentPaymentResponse,
  UserModel,
  UserProfileModel,
  UserValidationModel,
} from "../types/user";

export const validateUserEmail = async (
  email: string
): Promise<ApiResponse<UserValidationModel>> => {
  try {
    const response = await api.get<ApiResponse<UserValidationModel>>(
      `/User/UserEmailValidation?email=${email}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student details:", error);
    throw error;
  }
};

export const registerUser = async (
  user: UserModel
): Promise<ApiResponse<string>> => {
  try {
    const response = await api.post<ApiResponse<string>>(
      "/User/UserRegistration",
      user
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student details:", error);
    throw error;
  }
};

export const loginUser = async (
  user: UserModel
): Promise<ApiResponse<string>> => {
  try {
    const response = await api.post<ApiResponse<string>>(
      "/User/Userlogin",
      user
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student details:", error);
    throw error;
  }
};

export const userProfile = async (
  email: string
): Promise<ApiResponse<UserProfileModel>> => {
  try {
    const response = await api.get<ApiResponse<UserProfileModel>>(
      `/User/UserProfile?email=${email}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student details:", error);
    throw error;
  }
};

export const userPaymentHistory = async (
  studentId: string
): Promise<ApiResponse<StudentPaymentResponse[]>> => {
  try {
    const response = await api.get<ApiResponse<StudentPaymentResponse[]>>(
      `/User/GetStudentPaymentHistory?studentId=${studentId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student details:", error);
    throw error;
  }
};
